import { COUNTRY_CONFIGS, getCountryConfig } from '../constants/countryConfig';

// Support phone numbers are centralized in the domain-layer country-config (see CBU-21106)
// instead of a standalone constants map. GB customers fall back to the US number until
// CBU-21269 introduces GB-specific support contact info.
// Lazy getters avoid evaluating COUNTRY_CONFIGS at module init.
export const SupportPhoneNumbers = {
  get US() {
    return COUNTRY_CONFIGS.US.supportPhone;
  },
  get AU() {
    return COUNTRY_CONFIGS.AU.supportPhone;
  },
};

/**
 * Determines the appropriate support phone number based on customer country.
 *
 * @param {string} countryCode - Customer's country code (e.g., 'US', 'AU')
 * @returns {string} Support phone number to display
 *
 * @example
 * getSupportPhoneNumber('AU') // Returns '1800-290-803'
 * getSupportPhoneNumber('US') // Returns '855-229-5506'
 * getSupportPhoneNumber('UK') // Returns '855-229-5506' (GB supportPhone is null until CBU-21269)
 */
export const getSupportPhoneNumber = (countryCode) =>
  // null/undefined supportPhone intentionally falls back to the US number (see GB config).
  getCountryConfig(countryCode).supportPhone || SupportPhoneNumbers.US;
